import { render, staticRenderFns } from "./manifest_info.vue?vue&type=template&id=5827990c&scoped=true&"
import script from "./manifest_info.vue?vue&type=script&lang=js&"
export * from "./manifest_info.vue?vue&type=script&lang=js&"
import style0 from "./manifest_info.vue?vue&type=style&index=0&id=5827990c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5827990c",
  null
  
)

export default component.exports